export default "__VITE_ASSET__VNLem9B1__"